<template>
  <div id="page-wrap">
    <div class="container">
      <Application></Application>
      <Message></Message>
      <CloudDisk></CloudDisk>
    </div>
  </div>
</template>

<script>
export default {
  name: "Persona",
  components: {
    Application: () => import("./Application"),
    Message: () => import("./Message"),
    CloudDisk: () => import("./CloudDisk")
  },
  created() {
    this.$store.commit("SET_THEME", "个人中心");
  },
  computed: {
    theme() {
      return this.$store.state.app.theme;
    }
  }
};
</script>

<style scoped>
</style>